<template>
  <div :style="_style">
    <DropDownListComponent
      :value="modelValue"
      float-label-type="Auto"
      :placeholder="placeholder"
      :data-source="dataSource"
      :fields="fields"
      :name="name"
      :popup-width="popupWidth"
      @change="$emit('update:modelValue', $event.value)"
    />
  </div>
</template>

<script setup lang="ts">
import {DropDownListComponent} from "@syncfusion/ej2-vue-dropdowns";
import {computed} from "vue";

interface Props {
  name?: string
  placeholder?: string,
  modelValue?: string,
  dataSource?: any
  fields?: { text: string, value: string }
  popupWidth?: string
  width?: string

}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    name: undefined, placeholder: undefined, modelValue: undefined, dataSource: undefined,
    fields: () => {
      return {text: 'value', value: 'id'}
    },
    popupWidth: undefined,
    width: undefined
  }
)
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const emit = defineEmits(['update:modelValue'])

const _style = computed<string>(() => (props.width ? "width: " + props.width : ""))

</script>

<style scoped>

</style>
